<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="1300px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <div slot="title" class="d-flex align-items-center">
      <span class="el-dialog__title mr-2">
        {{ title }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <el-upload
        id="uploader"
        ref="uploader"
        multiple
        action="#"
        :show-file-list="false"
        :auto-upload="false"
        :on-change="onUploadChange"
        accept=".jpeg,.jpg,.png,.gif"
      >
        <el-button class="ml-2" style="font-size: 14px;" type="text">
          {{ '选择图片' }}
        </el-button>
      </el-upload>
    </div>
    <Main ref="main" :shipmentExpenseCode="shipmentExpenseCode" />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    shipmentExpenseCode: { type: String, default: '' },
  },
  data() {
    return {
      listImage: [],
      uploadFileMaxLimit: 10,
    }
  },
  methods: {
    onUploadChange(file) {
      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }

      this.listImage.push(file)
      if (this.listImage.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        this.clearFiles()
        return
      }

      const params = {
        shipmentExpenseCode: this.shipmentExpenseCode,
        listImage,
      }
      const res = await this.$api
        .shipmentExpenseUploadReceiptApi(params)
        .catch(() => null)
      this.loadingClose()
      this.clearFiles()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.$refs.main.getData()
    },
    uploadImages() {
      if (!this.listImage || !this.listImage.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImage.map(({ raw, name: fileName }) => {
        return this.$api
          .SYS_UPLOAD(raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileName,
            fileUrl: res.body.url,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImage = []
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
